import "../Model/Cell";
export class BoardsService {
    constructor(httpService, playerService, boardsFactory, realTimeService) {
        this.httpService = httpService;
        this.playerService = playerService;
        this.boardsFactory = boardsFactory;
        this.realTimeService = realTimeService;
    }
    async createBoard(gameId, gameCode) {
        if (!this.playerService.isRegistered.value) {
            throw new Error('No es posible crear un cartón mientras el jugador no está registrado.');
        }
        const response = await this.httpService.post('board', {
            gameId,
            gameCode,
            playerId: this.playerService.getPlayer().id,
        });
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al crear el cartón de juego.');
        }
    }
    async getBoard(gameId) {
        if (!this.playerService.isRegistered.value) {
            throw new Error('No es posible obtener un cartón mientras el jugador no está registrado.');
        }
        const response = await this.httpService.get(`board/${gameId}/${this.playerService.getPlayer().id}`);
        if (response.status === 404) {
            return null;
        }
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener el cartón de juego.');
        }
        return this.boardsFactory.createBoardFromDto(await response.json());
    }
    checkCell(boardId, number) {
        this.realTimeService.send('check_cell', { boardId, number });
    }
    async checkBoard(boardId, gameId, playerId, numbers) {
        const response = await this.httpService.post(`board/check`, { boardId, gameId, playerId, numbers });
        if (response.status === 404) {
            return null;
        }
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener el cartón de juego.');
        }
    }
}
